import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-brightcove-player-overlay',
  templateUrl: 'brightcove-player-overlay.component.html',
  styleUrls: ['brightcove-player-overlay.component.scss']

})
export class BrightcovePlayerOverlayComponent {
}
